import { useField } from 'formik'
import Styles from './TextStylesField.module.scss'
import { forwardRef } from 'react'
import { useObjectRef } from '@react-aria/utils'
import useButtonWithScrollCancel from 'hooks/useButtonWithScrollCancel'
import { FontPairingSwatch } from 'components/FontPairingSwatch/FontPairingSwatch'
import { useRootStore } from 'stores/RootStore'
import { FontPairingWithLabel, TextStylesFieldDrawer } from './TextStylesFieldDrawer'
import { FONT_PAIRINGS, FontPairing } from 'constants/fontPairings'
import { getBrandKitFontPairing } from 'hooks/queries/brandKits/getBrandKitFontPairing'
import { Ref } from 'components/DesignContentPreview/Types'
import { useFormBrandVisualKit } from 'components/Wizards/hooks/useFormBrandVisualKit'

interface Props {
  editorRef?: Ref
  templateTextStyles?: FontPairing
}

const TextStylesField = forwardRef<HTMLDivElement, Props>(({ editorRef, templateTextStyles }, fRef) => {
  const [{ value: textStyles }, , { setValue: setTextStyles }] = useField('text_styles')
  const kit = useFormBrandVisualKit()
  const { drawersStore } = useRootStore()

  const ref = useObjectRef<HTMLDivElement>(fRef)

  const { buttonProps } = useButtonWithScrollCancel(
    {
      onPress: () => {
        let pairings: FontPairingWithLabel[] = []
        if (templateTextStyles) {
          pairings = [{ fonts: templateTextStyles } as FontPairingWithLabel]
        }

        if (kit) {
          const kitPairing = getBrandKitFontPairing(kit)

          if (kitPairing) {
            pairings = pairings.concat([
              {
                label: kit.name,
                fonts: kitPairing,
              } as FontPairingWithLabel,
            ])
          }
        }

        pairings = pairings.concat(FONT_PAIRINGS.map((pairing) => ({ fonts: pairing })))
        drawersStore.openDrawer(TextStylesFieldDrawer, {
          initialValue: textStyles,
          pairings,
          onSelect: (pairing) => {
            setTextStyles(pairing)
          },
          editorRef,
        })
      },
      elementType: 'div',
    },
    ref,
  )

  return (
    <div className={Styles.button} {...buttonProps} ref={ref} aria-label="Switch Fonts">
      <div className={Styles.swatch}>
        <FontPairingSwatch pairing={textStyles} />
      </div>
      <span className={Styles.label}>Switch Fonts</span>
    </div>
  )
})

export { TextStylesField }
